import React from 'react';
import { Col, Row, Grid } from 'react-styled-flexboxgrid';
import Typography from '../Typography';
import { Button } from '@savewatersavemoney/swsm-ui';
import Styled from './ActionBanner.style';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

export interface ActionBannerProps {
  appWidth: number;
  user: any;
}

const ActionBanner: React.FC<ActionBannerProps> = props => {
  const { appWidth, user } = props;
  const note = _.get(user, 'data.note');
  const isDesktop = appWidth > 800;
  const [t] = useTranslation('common');
  const text = t(note);

  const [dismiss, setDismiss] = React.useState(!!note);
  const renderBanner = () => {
    return (
      <Styled.MessageWrap isDesktop={isDesktop}>
        <Typography size="p" text={text} />
        <Styled.MessageBtnWrap>
          <Button
            onClick={() => {
              setDismiss(true);
            }}
            appearance="OUTLINED"
            className="button-outline-white"
          >
            {t('portal.page_rewards.banner_button')}
          </Button>
        </Styled.MessageBtnWrap>
      </Styled.MessageWrap>
    );
  };

  return dismiss || !note ? null : (
    <Styled.Wrap>
      <Grid>
        <Row>
          <Col xs={12} sm={12} md={12}>
            {renderBanner()}
          </Col>
        </Row>
      </Grid>
    </Styled.Wrap>
  );
};

export default ActionBanner;
